var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notfound"}},[_c('div',{staticClass:"notfound"},[_vm._m(0),_c('router-link',{staticClass:"cursor-pointer",attrs:{"to":"/"}},[_c('span',{attrs:{"href":"/"}},[_vm._v("Home")])])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-404"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("This page is under construction and will be available in the future.")])])
}]

export { render, staticRenderFns }